/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListModelModulesParams,
  ModelLinkInput,
  ModelModule,
  ModelModuleDestroyBulkInput,
  ModelModuleInput,
  ModelModuleUpdateBulkInput,
  ModelModules,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create new Model Module
 */
export const createModelModule = (
    modelModuleInput: MaybeRefOrGetter<ModelModuleInput>,
 signal?: AbortSignal
) => {
      modelModuleInput = toValue(modelModuleInput);

      return axiosClient<ModelModule>(
      {url: `/model-modules`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modelModuleInput, signal
    },
      );
    }




export const getCreateModelModuleMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelModule>>, TError,CreateModelModuleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createModelModule>>, TError,CreateModelModuleMutationVariables, TContext> => {

const mutationKey = ['createModelModule'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createModelModule>>, CreateModelModuleMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createModelModule(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateModelModuleMutationResult = NonNullable<Awaited<ReturnType<typeof createModelModule>>>
    export type CreateModelModuleMutationBody = ModelModuleInput
    export type CreateModelModuleMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CreateModelModuleMutationVariables = {data: ModelModuleInput}

    /**
 * @summary Create new Model Module
 */
export const useCreateModelModule = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelModule>>, TError,CreateModelModuleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createModelModule>>,
        TError,
        CreateModelModuleMutationVariables,
        TContext
      > => {
      return useMutation(getCreateModelModuleMutationOptions(options), queryClient);
    }
    /**
 * @summary Model Modules list
 */
export const listModelModules = (
    params?: MaybeRefOrGetter<ListModelModulesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<ModelModules>(
      {url: `/model-modules`, method: 'GET',
        params, signal
    },
      );
    }




export const getListModelModulesQueryKey = (params?: MaybeRefOrGetter<ListModelModulesParams>,) => {
    return [
    'model-modules', ...(params ? [params] : [])
    ] as const;
    }


export const getListModelModulesQueryOptions = <TData = Awaited<ReturnType<typeof listModelModules>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ListModelModulesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listModelModules>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListModelModulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listModelModules>>> = ({ signal }) => listModelModules(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listModelModules>>, TError, TData>
}

export type ListModelModulesQueryResult = NonNullable<Awaited<ReturnType<typeof listModelModules>>>
export type ListModelModulesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Modules list
 */

export function useListModelModules<TData = Awaited<ReturnType<typeof listModelModules>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ListModelModulesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listModelModules>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListModelModulesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Bulk destroy model modules
 */
export const destroyBulkModelModule = (
    modelModuleDestroyBulkInput: MaybeRefOrGetter<ModelModuleDestroyBulkInput>,
 signal?: AbortSignal
) => {
      modelModuleDestroyBulkInput = toValue(modelModuleDestroyBulkInput);

      return axiosClient<void>(
      {url: `/model-modules/bulk`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: modelModuleDestroyBulkInput, signal
    },
      );
    }




export const getDestroyBulkModelModuleMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyBulkModelModule>>, TError,DestroyBulkModelModuleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyBulkModelModule>>, TError,DestroyBulkModelModuleMutationVariables, TContext> => {

const mutationKey = ['destroyBulkModelModule'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyBulkModelModule>>, DestroyBulkModelModuleMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  destroyBulkModelModule(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyBulkModelModuleMutationResult = NonNullable<Awaited<ReturnType<typeof destroyBulkModelModule>>>
    export type DestroyBulkModelModuleMutationBody = ModelModuleDestroyBulkInput
    export type DestroyBulkModelModuleMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyBulkModelModuleMutationVariables = {data: ModelModuleDestroyBulkInput}

    /**
 * @summary Bulk destroy model modules
 */
export const useDestroyBulkModelModule = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyBulkModelModule>>, TError,DestroyBulkModelModuleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyBulkModelModule>>,
        TError,
        DestroyBulkModelModuleMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyBulkModelModuleMutationOptions(options), queryClient);
    }
    /**
 * @summary Bulk update model modules
 */
export const updateBulkModelModule = (
    modelModuleUpdateBulkInput: MaybeRefOrGetter<ModelModuleUpdateBulkInput>,
 signal?: AbortSignal
) => {
      modelModuleUpdateBulkInput = toValue(modelModuleUpdateBulkInput);

      return axiosClient<void>(
      {url: `/model-modules/bulk`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modelModuleUpdateBulkInput, signal
    },
      );
    }




export const getUpdateBulkModelModuleMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBulkModelModule>>, TError,UpdateBulkModelModuleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateBulkModelModule>>, TError,UpdateBulkModelModuleMutationVariables, TContext> => {

const mutationKey = ['updateBulkModelModule'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBulkModelModule>>, UpdateBulkModelModuleMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateBulkModelModule(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBulkModelModuleMutationResult = NonNullable<Awaited<ReturnType<typeof updateBulkModelModule>>>
    export type UpdateBulkModelModuleMutationBody = ModelModuleUpdateBulkInput
    export type UpdateBulkModelModuleMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateBulkModelModuleMutationVariables = {data: ModelModuleUpdateBulkInput}

    /**
 * @summary Bulk update model modules
 */
export const useUpdateBulkModelModule = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBulkModelModule>>, TError,UpdateBulkModelModuleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateBulkModelModule>>,
        TError,
        UpdateBulkModelModuleMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateBulkModelModuleMutationOptions(options), queryClient);
    }
    /**
 * @summary Model Module destroy
 */
export const destroyModelModule = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/model-modules/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyModelModuleMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModelModule>>, TError,DestroyModelModuleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyModelModule>>, TError,DestroyModelModuleMutationVariables, TContext> => {

const mutationKey = ['destroyModelModule'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyModelModule>>, DestroyModelModuleMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyModelModule(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyModelModuleMutationResult = NonNullable<Awaited<ReturnType<typeof destroyModelModule>>>

    export type DestroyModelModuleMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyModelModuleMutationVariables = {id: string}

    /**
 * @summary Model Module destroy
 */
export const useDestroyModelModule = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModelModule>>, TError,DestroyModelModuleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyModelModule>>,
        TError,
        DestroyModelModuleMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyModelModuleMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Model Module
 */
export const modelModule = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ModelModule>(
      {url: `/model-modules/${id}`, method: 'GET', signal
    },
      );
    }




export const getModelModuleQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'model-modules',id
    ] as const;
    }


export const getModelModuleQueryOptions = <TData = Awaited<ReturnType<typeof modelModule>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelModule>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelModuleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelModule>>> = ({ signal }) => modelModule(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelModule>>, TError, TData>
}

export type ModelModuleQueryResult = NonNullable<Awaited<ReturnType<typeof modelModule>>>
export type ModelModuleQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Get Model Module
 */

export function useModelModule<TData = Awaited<ReturnType<typeof modelModule>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelModule>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelModuleQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Model Module
 */
export const updateModelModule = (
    id: MaybeRefOrGetter<string>,
    modelModuleInput: MaybeRefOrGetter<ModelModuleInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
modelModuleInput = toValue(modelModuleInput);

      return axiosClient<ModelModule>(
      {url: `/model-modules/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modelModuleInput, signal
    },
      );
    }




export const getUpdateModelModuleMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelModule>>, TError,UpdateModelModuleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateModelModule>>, TError,UpdateModelModuleMutationVariables, TContext> => {

const mutationKey = ['updateModelModule'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateModelModule>>, UpdateModelModuleMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateModelModule(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateModelModuleMutationResult = NonNullable<Awaited<ReturnType<typeof updateModelModule>>>
    export type UpdateModelModuleMutationBody = ModelModuleInput
    export type UpdateModelModuleMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateModelModuleMutationVariables = {id: string;data: ModelModuleInput}

    /**
 * @summary Update Model Module
 */
export const useUpdateModelModule = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelModule>>, TError,UpdateModelModuleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateModelModule>>,
        TError,
        UpdateModelModuleMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateModelModuleMutationOptions(options), queryClient);
    }
    /**
 * @summary Link Model Module to Model
 */
export const linkModelModule = (
    id: MaybeRefOrGetter<string>,
    modelLinkInput: MaybeRefOrGetter<ModelLinkInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
modelLinkInput = toValue(modelLinkInput);

      return axiosClient<ModelModule>(
      {url: `/model-modules/${id}/link`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modelLinkInput, signal
    },
      );
    }




export const getLinkModelModuleMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkModelModule>>, TError,LinkModelModuleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof linkModelModule>>, TError,LinkModelModuleMutationVariables, TContext> => {

const mutationKey = ['linkModelModule'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkModelModule>>, LinkModelModuleMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  linkModelModule(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkModelModuleMutationResult = NonNullable<Awaited<ReturnType<typeof linkModelModule>>>
    export type LinkModelModuleMutationBody = ModelLinkInput
    export type LinkModelModuleMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type LinkModelModuleMutationVariables = {id: string;data: ModelLinkInput}

    /**
 * @summary Link Model Module to Model
 */
export const useLinkModelModule = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkModelModule>>, TError,LinkModelModuleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof linkModelModule>>,
        TError,
        LinkModelModuleMutationVariables,
        TContext
      > => {
      return useMutation(getLinkModelModuleMutationOptions(options), queryClient);
    }
    /**
 * @summary Unlink Model Module from Model
 */
export const unlinkModelModule = (
    id: MaybeRefOrGetter<string>,
    modelLinkInput: MaybeRefOrGetter<ModelLinkInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
modelLinkInput = toValue(modelLinkInput);

      return axiosClient<ModelModule>(
      {url: `/model-modules/${id}/unlink`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modelLinkInput, signal
    },
      );
    }




export const getUnlinkModelModuleMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkModelModule>>, TError,UnlinkModelModuleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unlinkModelModule>>, TError,UnlinkModelModuleMutationVariables, TContext> => {

const mutationKey = ['unlinkModelModule'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlinkModelModule>>, UnlinkModelModuleMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  unlinkModelModule(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlinkModelModuleMutationResult = NonNullable<Awaited<ReturnType<typeof unlinkModelModule>>>
    export type UnlinkModelModuleMutationBody = ModelLinkInput
    export type UnlinkModelModuleMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UnlinkModelModuleMutationVariables = {id: string;data: ModelLinkInput}

    /**
 * @summary Unlink Model Module from Model
 */
export const useUnlinkModelModule = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkModelModule>>, TError,UnlinkModelModuleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unlinkModelModule>>,
        TError,
        UnlinkModelModuleMutationVariables,
        TContext
      > => {
      return useMutation(getUnlinkModelModuleMutationOptions(options), queryClient);
    }
